import { Amplify } from "aws-amplify";
import { env } from "./env";

// Configure at module load. Anything that imports from "aws-amplify/auth" must
// also import this module (or transitively depend on a module that does) so
// the configure call fires before getCurrentUser / signIn / etc. are invoked.
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: env.VITE_COGNITO_CLIENT_ID,
      loginWith: {
        email: true,
      },
    },
  },
});

// Re-exported as a no-op for callers that want to be explicit about the
// dependency. The configure above is what actually does the work.
export function configureAmplify(): void {
  /* configured at module load */
}
